var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-city",
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-institution-type", {
                          attrs: {
                            model: _vm.model.institution_type_id,
                            error: !!_vm.errors.institution_type_id,
                            errors: _vm.errors.institution_type_id,
                            label: "Tipo de Instituição*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "institution_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            type: "number",
                            step: "0.01",
                            suffix: "%",
                            clearable: "",
                            error: !!_vm.errors.min_master_doctors,
                            "error-messages": _vm.errors.min_master_doctors,
                            label: "% Mínimo Mestres/Doutores",
                            hint: "Deixe em branco quando não houver piso legal fixo",
                            "persistent-hint": "",
                          },
                          model: {
                            value: _vm.model.min_master_doctors,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "min_master_doctors", $$v)
                            },
                            expression: "model.min_master_doctors",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            type: "number",
                            step: "0.01",
                            suffix: "%",
                            clearable: "",
                            error: !!_vm.errors.min_fulltime,
                            "error-messages": _vm.errors.min_fulltime,
                            label: "% Mínimo Tempo Integral",
                            hint: "Deixe em branco quando não houver piso legal fixo",
                            "persistent-hint": "",
                          },
                          model: {
                            value: _vm.model.min_fulltime,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "min_fulltime", $$v)
                            },
                            expression: "model.min_fulltime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            label: "Base Legal / Observação",
                            rows: "3",
                          },
                          model: {
                            value: _vm.model.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "description", $$v)
                            },
                            expression: "model.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }